module.exports = __webpack_public_path__ + "img/alok.9c3bf05e.png";